<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-dedication element-without-heading" id="dedication">
<div class="text" id="dedication-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content">For Brian, Amy, Owen and Harry.</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">My greatest achievements.</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">My marriage, my children</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">and my grandson.</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">Of these, I am most proud.</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?a2a47fa6